import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';

@Component({
  selector: 'disabled-popup',
  templateUrl: './disabled-popup.component.html',
  styleUrls: ['./disabled-popup.component.less', '../../shared/common.less']
})
export class DisabledPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Input() contactDisabled: string = "";

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  ngOnInit() {}
}
